module.exports = __webpack_public_path__ + "img/wallet.e9133cf8.png";